import * as React from "react";
import {Ref} from "react";
import {logInKeycloack} from "../../actions/authActions";
import AuthUtils from "../../AuthUtils";
import Utils from "../../Utils";
import {useSelector} from "react-redux";
import './login.css'
import history from "../../config/history";
import {PublicRoutes} from "../../config/routes";

export default function Login(props: any) {
    const userNameRef: Ref<HTMLInputElement> = React.createRef();
    const passwordRef: Ref<HTMLInputElement> = React.createRef();
    const locale = useSelector((store: any) => store.auth.locale);

    const onLogIn = () => {
        const userName = userNameRef.current.value;
        const password = passwordRef.current.value;
        Utils.blurTheActiveElements();
        logInKeycloack(userName, password)
            .then(response => {
                if (response) {
                    AuthUtils.setSessionStorageTokens(response.data.access_token, response.data.refresh_token);
                    AuthUtils.mySelfRequest({locale: locale});
                }
            });
    };

    const onEnter = (e) => {
        if (e.which === 13) {
            onLogIn();
        }
    };

    const signUp = () => {
        history.push(`${process.env.ENV_PREFIX}${PublicRoutes.REGISTER}`)
    }

    const forgotPassword = () => {
        history.push(`${process.env.ENV_PREFIX}${PublicRoutes.FORGOT_PASS}`)
    }

    return (
        <div onKeyDown={onEnter} id='login-wrapper' className={'background-gradient'} style={{height: '100vh'}}>
            <div className={'app-wrapper-image login-background'}/>
            <div className="middle-box text-center loginscreen animated fadeInDown">
                <div className={'login-container'}>
                    <h1 style={{fontSize: 30, color: '#adadad', marginTop: 0}}>Welcome to BoCore</h1>
                    <div className="form-group">
                        <input ref={userNameRef} style={{borderRadius: 3}} type="text" className="form-control new-design"
                               placeholder="Username"/>
                    </div>
                    <div className="form-group">
                        <input ref={passwordRef} style={{borderRadius: 3}}
                               type="password" className="form-control new-design" placeholder="Password"/>
                    </div>
                    <button onClick={onLogIn} style={{width: "100%"}} className="btn new-style-btn">Login</button>
                    <div className={'register-forgotPass-container'}>
                        <p onClick={signUp}>Sign up</p>
                        <p onClick={forgotPassword}>Forgot password?</p>
                    </div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/components/Login/Login.tsx